function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStethoscope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "bd23e9e6-d349-43b7-8d38-8a1ad257f2cd",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 20 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b0d42697-4ea8-4788-bbee-1fc6cab2441f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20,1.69A1.47,1.47,0,0,0,18.44.19q-1.19,0-2.37,0c-.38,0-.55.17-.57.55V1.6c0,.41.19.58.6.59H18c0,.09,0,.14,0,.19,0,1.25,0,2.49,0,3.74a2.76,2.76,0,0,1-.21,1.07,16.4,16.4,0,0,1-1.22,2.16,2.46,2.46,0,0,1-4.15-.06l-.46-.69A4.63,4.63,0,0,1,11,6.13c0-1.29,0-2.58,0-3.87,0,0,0,0,0-.06h1.88c.39,0,.56-.18.57-.56s0-.59,0-.88-.17-.56-.58-.56H10.6A1.5,1.5,0,0,0,9,1.77C9,2.87,9,4,9,5.09a10.69,10.69,0,0,0,.1,1.26,10.59,10.59,0,0,0,2,4.6c.55.79,1.16,1.54,1.74,2.32a2.55,2.55,0,0,1,.63,1.5c0,1.05,0,2.1,0,3.15a4,4,0,0,1-2.58,3.57,5.92,5.92,0,0,1-2.25.26A4,4,0,0,1,4.5,17.63c0-1.09,0-2.18,0-3.27A.31.31,0,0,1,4.73,14,3.51,3.51,0,1,0,2.15,7.49,3.52,3.52,0,0,0,2.5,14.1c0,.86,0,1.72,0,2.58a14.07,14.07,0,0,0,.08,1.95,5.8,5.8,0,0,0,3.27,4.5,7.42,7.42,0,0,0,5.3.37,5.84,5.84,0,0,0,4.24-5c.1-.94,0-1.9.07-2.85,0-.65.1-1.3.17-2A.89.89,0,0,1,16,13c.46-.37.92-.74,1.35-1.14a7.67,7.67,0,0,0,2.51-5C20,5.14,20,3.41,20,1.69M3.62,12.91a1.82,1.82,0,1,1,.06-3.64,1.82,1.82,0,0,1-.06,3.64",
    style: {
      fill: "none",
      clipRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a7b9b98d-adc5-4e57-ba3e-14936970021a"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -367,
    y: -115.82,
    width: 1528,
    height: 1064,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b2ac534a-65ef-4873-b528-3adc7e896456"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.43,5H75.6a.94.94,0,0,0,.9-1,.94.94,0,0,0-.92-1H72.44a.93.93,0,0,0-.94,1,1,1,0,0,0,.93,1",
    style: {
      fill: "none",
      clipRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bfb3898c-f817-4c95-870e-b10e4bf7f642"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.5,5.12a.91.91,0,0,0,.94.88,1,1,0,0,0,1-.84c0-.77,0-1.55,0-2.33a.91.91,0,0,0-1-.83.94.94,0,0,0-1,.88V5.12",
    style: {
      fill: "none",
      clipRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ab5abc4e-ebf5-40f5-a776-f6d001ae50fa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.38,15.06a5.65,5.65,0,0,0-1.81-3.2.5.5,0,0,1-.12-.32c0-1.49,0-3,0-4.49,0-.62,0-1.25,0-1.87A2.22,2.22,0,0,0,80.53,3a10.61,10.61,0,0,0-1.26,0,.86.86,0,1,0,0,1.71c.32,0,.64,0,1,0a.5.5,0,0,1,.52.48c0,.55,0,1.11,0,1.67H66.18V5.37a.59.59,0,0,1,.64-.66h.82a.87.87,0,0,0,.81-.77A.84.84,0,0,0,67.79,3a6,6,0,0,0-1.58.05A2.24,2.24,0,0,0,64.5,5.37v11.5A2.37,2.37,0,0,0,65.57,19a2.62,2.62,0,0,0,1.45.35H73.8a.36.36,0,0,1,.33.15,5.52,5.52,0,0,0,5,2.54,5.33,5.33,0,0,0,3.74-1.69,5.7,5.7,0,0,0,1.55-5.25M73.28,17.6H66.87c-.47,0-.68-.2-.68-.68,0-2.72,0-5.45,0-8.17a.69.69,0,0,1,0-.13H80.75v2.11A5.52,5.52,0,0,0,75,11.9a5.84,5.84,0,0,0-1.76,5.7m5.52,2.69a4.09,4.09,0,1,1,4-4.06,4.05,4.05,0,0,1-4,4.06",
    style: {
      fill: "none",
      clipRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bb423bd9-327a-4f10-b3d4-22af11a9ec35"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.14,16a.57.57,0,0,1-.14-.42c0-.56,0-1.11,0-1.66s-.38-.93-.76-.9a.9.9,0,0,0-.73,1V15c0,.34,0,.69,0,1a1.27,1.27,0,0,0,.28.86c.47.59.94,1.18,1.42,1.76a.66.66,0,0,0,1.08,0,1.14,1.14,0,0,0,0-1.4L80.14,16",
    style: {
      fill: "none",
      clipRule: "evenodd"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#b0d42697-4ea8-4788-bbee-1fc6cab2441f)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#a7b9b98d-adc5-4e57-ba3e-14936970021a)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1,
    y: -0.82,
    width: 22,
    height: 25.8,
    style: {
      fill: "#516983"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStethoscope);
export default __webpack_public_path__ + "static/media/stethoscope.d34f33aecfd1b0acff3c1699ccc6db81.svg";
export { ForwardRef as ReactComponent };